import type { ApiResult, Result } from "../results/Result"
import Logger from '@yakit/core/logger'; const log = Logger(false)
import growl from "./notyf"
import { isEmpty } from '@yakit/core/utils'
import type { ValidationError, ValidationProblem } from "../results/ValidationProblem"
import type { Problem } from "../results/Problem";

async function handleError(er) {
  let errMsg = er
  //for cases when we are passing http error
  if (er.response) {
    errMsg = await problemErrorFromResponse(er)
  } else { // for cases when we are passing resolved promise, like for rpc
    errMsg = buildProblemError(er)
    log("handleError", errMsg)
  }
  log("errMsg", errMsg)
  growl.error(errMsg.message || '', errMsg.name)
}

export async function problemErrorFromResponse(er) {
  let problem = await er.response.json()
  let messages = []
  log("handleError", problem)
  //const message = er?.response?.status === 500 ? 'Unexpected error' : null
  return buildProblemError(problem)
}

function getValidationDetails(err: Result | Problem): string[] {
  if (!isEmpty(err.errors)) {

    return err.errors!.map(er =>
      formatError(er)
    )
  }
  return []
}

function formatError(err: ValidationError): string {
  if(err.field && err.message){
    return `${err.field}: ${err.message}`
  }
  if(err.message && !err.field){
    return err.message
  }
  if(!err.message && err.code){
    return err.code
  }
  return ''
}

function getProblemDetails(err: ApiResult): string[] {
  if(err.problems){
    return err.problems.reduce((acc: string[], problem) => {
      if (problem.errors){
        return [...acc, ...getValidationDetails(problem)]
      } else {
        if (problem.detail) {
          return [...acc, problem.detail]
        }
      }
      return acc
    }, [])
  }
  return []
}

export function buildProblemError(problem: Result): { name: string, message: string } {
  let details: string[] = problem?.detail ? [problem.detail] : []
  if (problem.errors) {
    details = getValidationDetails(problem)
  }

  if (problem.problems) {
    details = getProblemDetails(problem)
  }
  return {
    name: problem.title,
    message: formatDetails(details)
  }

}

function formatDetails(details: string[]): string {
  return `<ul>${details.map(detail => `<li>${detail}</li>`).join('')}</ul>`
}

export default {
  handleError, problemErrorFromResponse
}